module.exports = __webpack_public_path__ + "fonts/Gotham-BlackItalic.c9880664.otf";